export { CoverLetterAndResumeStatusMessages } from './CoverLetterAndResumeStatusMessages';
